import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../../../Components/ClientComp/heroSection/heroSection';
import NosChambres from '../../../Components/ClientComp/MainContent/nosChambres/nosChambres.jsx';
import NosSuites from '../../../Components/ClientComp/MainContent/nosSuites/nosSuites.js';
import Restauration from '../../../Components/ClientComp/MainContent/restauration/restauration.js';
import NosServices from '../../../Components/ClientComp/MainContent/nosServices/nosService.js';
import Gallerie from '../../../Components/ClientComp/MainContent/gallerie/gallerie.js';
import ContactezNous from '../../../Components/ClientComp/MainContent/contacterNous/contactezNous.js';
import './HomePage.css';

const HomePage = () => {
  const location = useLocation();
  const videoRef = useRef(null);
  const hasInteracted = useRef(false);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const scrollId = location?.state?.scrollToId;
    if (scrollId) {
      const element = document.getElementById(scrollId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;
    video.play().catch(console.error);

    const handleUserInteraction = () => {
      hasInteracted.current = true;
      video.muted = false;
      video.play().catch(console.error);
      setIsMuted(false);
      localStorage.setItem('videoSoundEnabled', 'true');
      window.removeEventListener('click', handleUserInteraction);
    };

    window.addEventListener('click', handleUserInteraction);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!hasInteracted.current) return;
        if (entry.isIntersecting) {
          video.muted = false;
          setIsMuted(false);
          video.play().catch(console.error);
        } else {
          video.muted = true;
          setIsMuted(true);
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(video);

    return () => {
      observer.disconnect();
      window.removeEventListener('click', handleUserInteraction);
    };
  }, []);

  const toggleMute = () => {
    const video = videoRef.current;
    if (video) {
      video.muted = !video.muted;
      setIsMuted(video.muted);
    }
  };

  return (
    <div className="home-page">
      <div className="image-container">
        <video
          ref={videoRef}
          className="video"
          autoPlay
          loop
          muted
          playsInline
          controls
          style={{ width: '100%', height: 'auto' }}
        >
          <source
            src="https://github.com/Meriemlbrch/vidoe-hotel/raw/main/videos/video1.mp4"
            type="video/mp4"
          />
          Votre navigateur ne supporte pas la lecture vidéo.
        </video>

        <HeroSection />

        <div id="chambres">
          <NosChambres />
        </div>
        <div id="suite">
          <NosSuites />
        </div>
        <div id="restauration">
          <Restauration />
        </div>
        <div id="services">
          <NosServices />
        </div>
        <div id="gallerie">
          <Gallerie />
        </div>
        <div id="contact">
          <ContactezNous />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
